import { render, staticRenderFns } from "./StackedChart.vue?vue&type=template&id=6ec2a54e&"
import script from "./StackedChart.vue?vue&type=script&lang=ts&"
export * from "./StackedChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports